import { InjectionToken } from '@angular/core';

export const ADYEN_CLIENT_KEY = new InjectionToken<string>('Adyen client key');
